export const PROVIDERS = {
  RENTING_CARTZ: 'RentingCarz'
};
